import React from 'react';
import PropTypes from 'prop-types';
import { Link } from 'react-router-dom';
import styles from './CardSpectacleList.module.css';
import Button from 'components/common/Button';

const CardSpectacleList = ({ name, plage_date, poster, typeShow, link }) => {
  return (
    <li className={styles.card}>
      <Link to={link} className={styles.imageWrapper}>
        <img
          src={poster?.path || '/images/card/card-no-image.jpg'}
          alt={`Image de ${name}`}
          className={styles.image}
        />
      </Link>
      <div className={styles.content}>
        <Link to={link} className={styles.title}>{name}</Link>
        <p className={`${styles.date} ${typeShow?.code === 'concert' ? styles.dateConcert : ''}`}>{plage_date}</p>
        <p className={styles.type}>{typeShow?.name}</p>
      </div>
      <div className={styles.button}>
        <Link to={link}>
          <Button variant={`${typeShow?.code === 'concert' ? 'secondary' : 'primary'}`} as="a" href={link}>
            Commander
          </Button>
        </Link>
      </div>
    </li>
  );
};

CardSpectacleList.propTypes = {
  name: PropTypes.string.isRequired,
  plage_date: PropTypes.string,
  poster: PropTypes.shape({
    path: PropTypes.string,
  }),
  typeShow: PropTypes.shape({
    code: PropTypes.string,
    name: PropTypes.string,
  }),
  link: PropTypes.string.isRequired,
};

export default CardSpectacleList;
